import { Link, LinkText } from '../Link';
import { QuickLinkItem } from './QuickLinkItem';

export interface IQuickLinkInternalProps {
	title: string;
	url: string;
}

export function QuickLinkInternal({ title, url }: IQuickLinkInternalProps) {
	return (
		<QuickLinkItem>
			<Link href={url}>
				<LinkText>{title}</LinkText>
			</Link>
		</QuickLinkItem>
	);
}
